import WangEditor from '@/components/WangEditorV3Deprecated'

export default {
  components: {WangEditor},
  data () {
    return {
      inputWith: 12,
      id: 0,
      form: {
        name: '',
        type: '',
        status: '',
        mail_title: '',
        mail_content: ''
      },
      formRules: {
        name: [
          {required: true, message: '名称不能为空', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '类型不能为空', trigger: 'blur'},
        ],
        status: [
          {required: true, message: '状态不能为空', trigger: 'blur'},
        ],
        mail_title: [
          {required: true, message: '邮件标题不能为空', trigger: 'blur'},
        ],
        mail_content: [
          {required: true, message: '邮件正文不能为空', trigger: 'blur'},
        ],
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.satisfactionEmail.options,
    }),
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    setForm (id) {
      request.page('getSatisfactionEmailDetail', {id}).then(({data}) => {
        filter.setLoop(this.form, data)
      })
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createSatisfactionEmailData', this.form).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({name: '满意度邮件'})
        })
      })
    },
    update (id) {
      request.common('updateSatisfactionEmailData', {id, ...this.form}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({name: '满意度邮件'})
        })
      })
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/satisfaction-email/pages/SatisfactionEmailForm.js